import React, {useEffect, useState} from 'react';
// import styles from './UsersTable.module.scss';
import {$t} from "../../helpers/translator";
import api from "../../helpers/api";
import DataTable from "../miscellaneous/DataTable/DataTable";
import Timestamp from "../miscellaneous/Timestamp/Timestamp";
import Input from "../miscellaneous/Input/Input";
import MultiSelect from "../miscellaneous/MultiSelect/MultiSelect";
import _ from "lodash";
import {Link} from "react-router-dom";
import Tooltip from "../miscellaneous/Tooltip/Tooltip";
import {useDispatch} from "react-redux";
import {getPermissionsByRole} from "../../store/data-slice";


const UsersTable = (props) => {
    const dispatch = useDispatch();
    const [isTableLoading, setIsTableLoading] = useState(false);
    const [usersData, setUsersData] = useState([]);               //table of users' data
    const [pagination, setPagination] = useState({});
    const [payload, setPayload] = useState({
        page: 1,
        sort: 'created_at',
        order: 'asc',   // or desc

        clinic_id: props.clinicId ? props.clinicId : '',
        distributor_id: props.distributorId ? props.distributorId : '',
        role: '',
        sub_role: '',
        search: ''
    })

    const [role, setRole] = useState({label: $t('global.users.all'), value: ''});
    const roleOptions = [
        {label: $t('global.users.all'), value: ''},
        {label: $t('global.users.clinic'), value: '2'},
        {label: $t('global.users.chain'), value: '3'},
        {label: $t('global.users.distributor'), value: '4'},
        {label: $t('global.users.admin'), value: '5'},
    ]

    const [subRole, setSubRole] = useState({label: $t('global.users.all'), value: 'TBD - ROLES'});
    const [subRoleOptions, setSubRoleOptions] = useState([])


    useEffect(() => {
        getUsers();
        getSubRoles();
    }, [payload])

    useEffect(() => {
        let newPayload = {...payload}
        if (props.clinic) {
            if (props.clinic.is_chain) {
                newPayload.role = 3
            } else {
                newPayload.role = 2
            }
        }
        setPayload(newPayload)
    }, [props.clinic])

    useEffect(() => {
        let newPayload = {...payload}

        if (props.distributorId) {
            newPayload.role = 4
        }
        setPayload(newPayload)
    }, [props.distributorId])


    const getUsers = async () => {
        setIsTableLoading(true);

        try {
            let res = await api.get(`user/all?page=${payload.page}&sort=${payload.sort}&order=${payload.order}&clinic_id=${payload.clinic_id}&distributor_id=${payload.distributor_id}&role=${payload.role}&sub_role=${payload.sub_role}&search=${payload.search}`);
            //console.log(res.data.data);
            if (!res || !res.success || !res.data || !res.data.success) {
                // console.log('errr')
                return;
            }

            let data = [];
            _.forEach(res.data.data.data, (v, k) => {
                let originalDistributorName = v.distributor_name;

                v.clinic_name = v.clinic_id && v.clinic_name ?
                    <div>{`${v.clinic_name}`}</div> : '-';

                v.distributor_name = v.distributor_id && v.distributor_name ?
                    <Tooltip content={`${$t('global.users.goTo')} ${v.distributor_name}`}><Link
                        to={`/distributor/${v.distributor_id}`}>{`${v.distributor_name}`}</Link></Tooltip> : '-';

                if (props.distributorId && v.distributor_id && v.distributor_name) {
                    v.distributor_name = originalDistributorName;
                }

                v.role = $t(`global.general.roles.${v.role}`)

                data.push(v);
            })

            setPagination(res.data.data.pagination)
            setUsersData(data);
        } catch (e) {
            console.error('err get users:', e);
        } finally {
            setIsTableLoading(false);
        }
    }

    const getSubRoles = async () => {
        // console.log('getSubRoles', payload.role)

        let subRolesArray = [];
        subRolesArray.push({label: 'All', value: ''});
        if (payload.role) {
            let subRoles = await dispatch(getPermissionsByRole(payload.role));
            _.forEach(subRoles, (v,k) => {
                subRolesArray.push(v)
            })
        }

        setSubRoleOptions(subRolesArray)
    }

    const dataTableActionHandler = (data) => {
        // console.log(data)
        if (data.key === 'page') {
            setPayload({...payload, page: data.value});
        } else if (data.key === 'header') {
            const newPayload = {...payload};
            if (payload.sort === data.value) {
                newPayload.order = payload.order === 'desc' ? 'asc' : 'desc'
            }
            newPayload.sort = data.value;
            setPayload(newPayload);
        }
    }

    const searchHandler = (value) => {
        // console.log(value);

        let newPayload = {...payload};
        newPayload.page = 1;
        newPayload.search = value;
        setPayload(newPayload)
    }

    const selectionHandler = async (name, data) => {
        // console.log(data)

        let newPayload = {...payload};
        newPayload.page = 1;

        if (name === 'role') {
            setRole(data);
            setSubRole({value: '', label: 'All'})
            newPayload.role = data.value;
            newPayload.sub_role = '';
        }

        if (name === 'subRole') {
            setSubRole(data);
            newPayload.sub_role = data.value;
        }

        setPayload(newPayload)
    }

    let tableHeaders = [
        // {
        //     name: $t('global.users.id'),
        //     id: 'id',
        //     clickable: true
        // },
        {
            name: $t('global.users.name'),
            id: 'name',
            clickable: true
        },
        {
            name: $t('global.users.email'),
            id: 'email',
            clickable: true
        },
        {
            name: $t('global.users.type'),
            id: 'role',
            clickable: true
        },
        {
            name: $t('global.users.subRole'),
            id: 'sub_role',
            clickable: true,
            render: (value) => {
                return <span>{value ? value.charAt(0).toUpperCase() + value.slice(1) : ''}</span>
            }
        },
        {
            name: $t('global.users.clinic'),
            id: 'clinic_name',
            clickable: true
        },
        {
            name: $t('global.users.distributor'),
            id: 'distributor_name',
            clickable: true
        },
        {
            name: $t('global.users.personalId'),
            id: 'personal_id',
            clickable: true
        },
        {
            name: $t('global.users.created_at'),
            id: 'created_at',
            clickable: true,
            render: (value) => {
                return <Timestamp time={value}/>
            }
        },

    ];

    return (
        <>
            <div className={'container'}>
                <div className={'box'}>
                    <div className={'alma-box'}>
                        <div className={'alma-box-header'}>
                            <div><h3>{props.header ? props.header : $t('global.account.accountUsers')}</h3></div>
                            {/*<HasPermission permission="user.create">*/}
                            {/*    <div className={ styles[ 'add-patient-button' ] }*/}
                            {/*        onClick={ () => {*/}
                            {/*            setAddUserKey(addUserKey + 1);*/}
                            {/*            setShowAddEditUser(true);*/}
                            {/*        } }>*/}
                            {/*        { $t('global.account.addAccountUser') }*/}
                            {/*    </div>*/}
                            {/*</HasPermission>*/}
                        </div>

                        <div>
                            <div className={'alma-fields-row'}>
                                <div className={'alma-field-container'}>
                                    <div className={'alma-field-header'}>{$t('global.users.search')}</div>
                                    <Input name="search"
                                           autoComplete={false}
                                           delay={500}
                                           className={`${'alma-input'}`}
                                           type="text"
                                           value={payload.search}
                                           placeholder={$t('global.users.searchByUser')}
                                           onChange={(e) => searchHandler(e.target.value)}/>
                                </div>
                                {props.clinicId || props.distributorId ?
                                    null
                                    :
                                    <div className={'alma-field-container'}>
                                        <div className={'alma-field-header'}>{$t('global.users.type')}</div>
                                        <MultiSelect
                                            searchable
                                            options={roleOptions}
                                            selected={role}
                                            onValueChange={(data) => {
                                                selectionHandler('role', data)
                                            }}
                                        />
                                    </div>
                                }

                                        <div className={'alma-field-container'}>
                                            <div className={'alma-field-header'}>{$t('global.users.subRole')}</div>
                                            <MultiSelect
                                                searchable
                                                options={subRoleOptions}
                                                selected={subRole}
                                                onValueChange={(data) => {
                                                    selectionHandler('subRole', data)
                                                }}
                                                disabled={!payload.role}
                                            />
                                        </div>

                            </div>

                            <DataTable data={usersData}
                                       headers={tableHeaders}
                                       pagination={pagination}
                                       loading={isTableLoading}
                                       onAction={(e) => dataTableActionHandler(e)}
                            />
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default UsersTable;

